import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/zh-cn";
import dayjs from "dayjs";
import { TextField } from "@mui/material";

function MyDatePicker({ label = "选择日期", defaultValue, onChange }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
      <DatePicker
        label={label}
        // value={form.publishTime}
        defaultValue={dayjs(defaultValue || "")}
        onChange={onChange}
        renderInput={(params) => <TextField size="small" {...params} />}
      />
    </LocalizationProvider>
  );
}

export default MyDatePicker;
